import type React from "react";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@planta-v2/pds-ui/card";
import { i18n } from "@frontend/i18n";

export function UnauthorizedPage(): React.JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle
            className="text-center text-2xl"
            data-testid="unauthorized-title"
          >
            {i18n.t("common.unauthorized.title")}
          </CardTitle>
          <CardDescription className="text-center">
            {i18n.t("common.unauthorized.message")}
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}
